// FizzyIQ — Ingredients master-detail + COA modal
// Ported from /design_handoff_ingredients_section/ingredients-section.html.
(function () {

  /* ────────────── INGREDIENT DATA ────────────── */
  // `desc`       — body of the "Why we use it" accordion
  // `whatIsIt`   — body of the "What is it" accordion
  var INGREDIENTS = [
  {
    "k": "vitc",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/strawberry.png?v=1716870211&width=1440",
    "n": "Vitamin C",
    "bene": "Normal immune function",
    "kind": "Vitamin",
    "swatch": "radial-gradient(circle at 50% 40%, #E8A33D 0%, #B5651A 70%)",
    "dose": "150mg",
    "form": "Ascorbic Acid",
    "src": "Naturally found in citrus and berries",
    "whatIsIt": "Vitamin C, also called ascorbic acid, is an essential water-soluble vitamin. Food examples illustrate where vitamin C occurs naturally, not our supplier origin.",
    "desc": "Vitamin C contributes to normal immune function, collagen production and antioxidant activity.* FizzyFocus includes 150 mg per serving.",
    "chips": [
      "Ascorbic acid",
      "150 mg per serving"
    ]
  },
  {
    "k": "b6",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/avocado_vitamin_b6.png?v=1715376144&width=1440",
    "n": "Vitamin B6",
    "bene": "Nutrient metabolism",
    "kind": "Vitamin",
    "swatch": "radial-gradient(circle at 50% 40%, #6BA36B 0%, #2E5D3A 70%)",
    "dose": "10mg",
    "form": "Pyridoxal-5-Phosphate",
    "src": "Naturally found in foods including poultry and chickpeas",
    "whatIsIt": "Pyridoxal-5-phosphate (P-5-P) is an active phosphorylated form of vitamin B6, not methylated B6. Phosphorylated forms are processed before absorption.",
    "desc": "Vitamin B6 participates in normal amino acid metabolism and neurotransmitter synthesis.* It is included alongside folate and B12 as part of the formula.",
    "chips": [
      "P-5-P form",
      "10 mg per serving"
    ]
  },
  {
    "k": "folate",
    "img": "https://cdn.shopify.com/s/files/1/0631/8915/5937/files/spinach.png?v=1779829747&width=1440",
    "n": "L-Methylfolate",
    "bene": "Normal cell function",
    "kind": "Vitamin",
    "swatch": "radial-gradient(circle at 50% 40%, #4F8F5E 0%, #1A3B26 70%)",
    "dose": "150mcg DFE",
    "form": "L-5-MTHF Calcium",
    "src": "Folate occurs naturally in leafy greens and legumes",
    "whatIsIt": "L-methylfolate is a form of folate used in supplements. Common MTHFR variants do not mean a person cannot process folic acid.",
    "desc": "Folate participates in cell division and one-carbon metabolism, including methylation pathways.* The formula includes L-methylfolate alongside methylcobalamin B12.",
    "chips": [
      "L-methylfolate",
      "150 mcg DFE"
    ]
  },
  {
    "k": "b12",
    "img": "https://cdn.shopify.com/s/files/1/0631/8915/5937/files/yeast.png?v=1779829744&width=1440",
    "n": "Vitamin B12",
    "bene": "Nervous-system function",
    "kind": "Vitamin",
    "swatch": "radial-gradient(circle at 50% 40%, #E8A33D 0%, #7E4F12 70%)",
    "dose": "250mcg",
    "form": "Methylcobalamin",
    "src": "Naturally found in animal foods; also added to fortified foods",
    "whatIsIt": "Methylcobalamin is one of the active forms of vitamin B12. The name of a supplemental form alone does not establish superior absorption.",
    "desc": "Vitamin B12 contributes to normal nervous-system function, red blood cell formation and DNA synthesis.* FizzyFocus includes methylcobalamin B12.",
    "chips": [
      "Methylcobalamin",
      "250 mcg per serving"
    ]
  },
  {
    "k": "saffron",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/saffron.png?v=1715310531&width=1440",
    "n": "Saffron",
    "bene": "Saffron extract",
    "kind": "Plant ingredient",
    "swatch": "radial-gradient(circle at 50% 40%, #D94A2A 0%, #6C1A0E 70%)",
    "dose": "15mg",
    "form": "Crocus Sativus (Affron®)",
    "src": "Crocus sativus flower stigmas",
    "whatIsIt": "Saffron comes from the Crocus sativus flower. We chose 15 mg affron® per serving with the full formula in mind.",
    "desc": "affron® is a standardized saffron extract. It has been studied for mood in teens; that research used a different daily amount and did not test FizzyFocus.* See Clinical ingredient studies for the findings and study details.",
    "chips": [
      "Affron®",
      "15 mg per serving"
    ]
  },
  {
    "k": "blueberry",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/blueberries.png?v=1715376402&width=1440",
    "n": "Wild Blueberry",
    "bene": "Fruit blend",
    "kind": "Plant ingredient",
    "swatch": "radial-gradient(circle at 50% 40%, #5E6FB8 0%, #1E2850 70%)",
    "dose": "In 150 mg blend",
    "form": "Organic whole-fruit extract",
    "src": "Blueberry fruit",
    "whatIsIt": "Blueberry is one of the three fruits in the combined 150 mg fruit blend, alongside cranberry and pomegranate.",
    "desc": "Blueberries contain plant compounds including polyphenols. The label lists the combined blend amount, not an individual blueberry amount. It is not equivalent to the amounts used in whole-fruit studies.",
    "chips": [
      "Three-fruit blend",
      "Combined 150 mg"
    ]
  },
  {
    "k": "cranberry",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/cranberry.png?v=1715377220&width=1440",
    "n": "Cranberry",
    "bene": "Fruit blend",
    "kind": "Plant ingredient",
    "swatch": "radial-gradient(circle at 50% 40%, #C63552 0%, #4A0F1E 70%)",
    "dose": "In 150 mg blend",
    "form": "Organic whole-fruit",
    "src": "Cranberry fruit",
    "whatIsIt": "Cranberry is one of the three fruits in the combined 150 mg fruit blend, alongside blueberry and pomegranate.",
    "desc": "Cranberries contain plant compounds including polyphenols. The label lists the combined blend amount, not an individual cranberry amount.",
    "chips": [
      "Three-fruit blend",
      "Combined 150 mg"
    ]
  },
  {
    "k": "zinc",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/nuts_zinc.png?v=1715467379&width=1440",
    "n": "Zinc",
    "bene": "Normal cell function",
    "kind": "Mineral",
    "swatch": "radial-gradient(circle at 50% 40%, #A8ADB6 0%, #3E4452 70%)",
    "dose": "12.5mg",
    "form": "Zinc Picolinate",
    "src": "Zinc occurs naturally in foods including nuts and seeds",
    "whatIsIt": "Zinc is an essential mineral involved in normal cell signaling, growth and immune function.* Zinc picolinate is the form listed in FizzyFocus.",
    "desc": "FizzyFocus contains 12.5 mg zinc per serving. Consider total intake from food and other supplements with your clinician, particularly for younger children.",
    "chips": [
      "Zinc picolinate",
      "12.5 mg per serving"
    ]
  },
  {
    "k": "mag",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/banana_magnesium.png?v=1715466851&width=1440",
    "n": "Magnesium",
    "bene": "Nerve and muscle function",
    "kind": "Mineral",
    "swatch": "radial-gradient(circle at 50% 40%, #E8E2CC 0%, #8A8265 70%)",
    "dose": "100mg",
    "form": "Magnesium Glycinate",
    "src": "Naturally found in leafy greens, nuts and whole grains",
    "whatIsIt": "Magnesium is an essential mineral involved in normal nerve and muscle function and energy metabolism.* The glycinate form combines magnesium with glycine.",
    "desc": "FizzyFocus includes 100 mg magnesium per serving. The amount matters alongside other supplements and the current label directions.",
    "chips": [
      "Magnesium glycinate",
      "100 mg per serving"
    ]
  },
  {
    "k": "pom",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/pomegranate.png?v=1715454189&width=1440",
    "n": "Pomegranate",
    "bene": "Fruit blend",
    "kind": "Plant ingredient",
    "swatch": "radial-gradient(circle at 50% 40%, #B02848 0%, #3A0912 70%)",
    "dose": "In 150 mg blend",
    "form": "Organic whole-fruit",
    "src": "Pomegranate fruit",
    "whatIsIt": "Pomegranate is one of the three fruits in the combined 150 mg fruit blend, alongside blueberry and cranberry.",
    "desc": "Pomegranate contains plant compounds including polyphenols. The label discloses the combined fruit blend amount, not an individual pomegranate amount.",
    "chips": [
      "Three-fruit blend",
      "Combined 150 mg"
    ]
  },
  {
    "k": "theanine",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/black_tea_l-theanine.png?v=1715453850&width=1440",
    "n": "L-Theanine + Caffeine",
    "bene": "A specific pairing",
    "kind": "Formula pairing",
    "swatch": "radial-gradient(circle at 50% 40%, #4F8F5E 0%, #183420 70%)",
    "dose": "100mg / 50mg",
    "form": "L-theanine + natural green-tea caffeine",
    "src": "Our caffeine comes from natural green tea",
    "whatIsIt": "Each serving pairs 100 mg L-theanine with 50 mg caffeine from natural green tea. Green tea also naturally contains EGCG, a tea polyphenol. Caffeine is a stimulant, including when it comes from green tea.",
    "desc": "Caffeine is included for its role in alertness.* FizzyFocus pairs 50 mg caffeine from natural green tea with 100 mg L-theanine per serving. Green tea also naturally contains EGCG, a tea polyphenol. See Clinical ingredient studies for the findings and study details.",
    "chips": [
      "100 mg L-theanine",
      "50 mg caffeine from natural green tea"
    ]
  },
  {
    "k": "vitd",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/mushroom_vitamin_D.png?v=1715567139&width=1440",
    "n": "Vitamin D3",
    "bene": "Bone and immune function",
    "kind": "Vitamin",
    "swatch": "radial-gradient(circle at 50% 40%, #F0C04B 0%, #8A5614 70%)",
    "dose": "13mcg",
    "form": "Cholecalciferol",
    "src": "Vitamin D is made in skin exposed to sunlight; foods include UV-exposed mushrooms, fatty fish and fortified foods",
    "whatIsIt": "Cholecalciferol is vitamin D3, a form used in supplements and also produced in skin in response to sunlight. This does not identify the supplier source.",
    "desc": "Vitamin D contributes to calcium absorption, bone health and normal immune function.* FizzyFocus includes 13 mcg vitamin D3 per serving.",
    "chips": [
      "Cholecalciferol",
      "13 mcg per serving"
    ]
  },
  {
    "k": "ps",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/nuts_zinc.png?v=1715467379&width=1440",
    "n": "Phosphatidylserine",
    "bene": "Cell membrane component",
    "kind": "Phospholipid",
    "swatch": "radial-gradient(circle at 50% 40%, #E0B26E 0%, #6E4A1A 70%)",
    "dose": "100mg",
    "form": "Non-GMO soy-derived",
    "src": "Soy-derived, as stated on the label",
    "whatIsIt": "Phosphatidylserine is a phospholipid found in cell membranes. The ingredient in FizzyFocus is derived from non-GMO soy.",
    "desc": "FizzyFocus includes 100 mg phosphatidylserine per serving. Review the complete label, especially if you have a soy allergy.",
    "chips": [
      "Soy-derived",
      "100 mg per serving"
    ]
  },
  {
    "k": "grape",
    "img": "https://cdn.shopify.com/s/files/1/0756/5194/0663/files/grapes.png?v=1715382975&width=1440",
    "n": "Grape Seed",
    "bene": "Plant extract",
    "kind": "Plant ingredient",
    "swatch": "radial-gradient(circle at 50% 40%, #7C2B5A 0%, #23071A 70%)",
    "dose": "100mg",
    "form": "Organic Grape Seed Extract (Vitis vinifera)",
    "src": "Grape seeds",
    "whatIsIt": "Grape seed extract contains plant compounds known as polyphenols. FizzyFocus includes 100 mg per serving.",
    "desc": "Grape seed extract is included alongside the three-fruit blend. Ingredient research does not establish an expected cognitive result from this combined drink.",
    "chips": [
      "Grape seed extract",
      "100 mg per serving"
    ]
  }
];

  /* ────────────── REFERENCE STUDIES (per ingredient) ──────────────
     Verified human studies keyed by ingredient `k`, mirrored in
     fizzy-ingredient-data.js. Designs, findings and applicability are explicit;
     open studies and null findings are not presented as proof of benefit. */
  var REFS = {
  "vitc": [
    {
      "t": "Salvat et al. (2022): diet in children with A*HD",
      "s": "A case-control study compared the diets of 100 children aged 5\u201313 with A*HD and 100 children without it. Children with A*HD ate less vitamin C, zinc, protein and some B vitamins, and more simple sugars. This shows a difference in diet, not that vitamin C improves attention. No trial has tested vitamin C on its own in children with A*HD, and this study did not test FizzyFocus.",
      "c": "Salvat et al. (2022): diet in children with A*HD. A case-control study compared the diets of 100 children aged 5\u201313 with A*HD and 100 children without it. Children with A*HD ate less vitamin C, zinc, protein and some B vitamins, and more simple sugars. This shows a difference in diet, not that vitamin C improves attention. No trial has tested vitamin C on its own in children with A*HD, and this study did not test FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/35093041/"
    },
    {
      "t": "Sim et al. (2022): vitamin C and attention in young adults",
      "s": "Placebo-controlled trial in adults: 46 young adults with low vitamin C levels were randomized to 1,000 mg/day or placebo for four weeks. Attention ratings and Stroop-task performance improved versus placebo; mood did not. This was an adult study, not a children\u2019s trial. FizzyFocus provides 150 mg per serving; the finished formula was not tested.",
      "c": "Sim et al. (2022): vitamin C and attention in young adults. Placebo-controlled trial in adults: 46 young adults with low vitamin C levels were randomized to 1,000 mg/day or placebo for four weeks. Attention ratings and Stroop-task performance improved versus placebo; mood did not. This was an adult study, not a children\u2019s trial. FizzyFocus provides 150 mg per serving; the finished formula was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/34476568/"
    }
  ],
  "b6": [
    {
      "t": "Mousain-Bosc et al. (2006): magnesium with vitamin B6 in children with A*HD",
      "s": "An open study gave 40 children with A*HD symptoms magnesium (6 mg/kg) with vitamin B6 (0.6 mg/kg) daily for at least eight weeks. Researchers reported lower hyperactivity scores and better school attention in almost all cases, and symptoms returned within weeks of stopping. There was no placebo group, so it cannot show cause or separate B6 from magnesium. For a 30 kg child that is about 18 mg B6; FizzyFocus provides 10 mg as P-5-P.",
      "c": "Mousain-Bosc et al. (2006): magnesium with vitamin B6 in children with A*HD. An open study gave 40 children with A*HD symptoms magnesium (6 mg/kg) with vitamin B6 (0.6 mg/kg) daily for at least eight weeks. Researchers reported lower hyperactivity scores and better school attention in almost all cases, and symptoms returned within weeks of stopping. There was no placebo group, so it cannot show cause or separate B6 from magnesium. For a 30 kg child that is about 18 mg B6; FizzyFocus provides 10 mg as P-5-P.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/16846100/"
    },
    {
      "t": "Wang et al. (2019): B vitamin levels in children with A*HD",
      "s": "A case-control study of 216 children with A*HD and 216 matched children in Taiwan found lower blood levels of vitamin B6, folate and vitamin B12 in the A*HD group, along with diets higher in sugar and fat. This is an association; it does not show that supplements change attention, and it did not test FizzyFocus.",
      "c": "Wang et al. (2019): B vitamin levels in children with A*HD. A case-control study of 216 children with A*HD and 216 matched children in Taiwan found lower blood levels of vitamin B6, folate and vitamin B12 in the A*HD group, along with diets higher in sugar and fat. This is an association; it does not show that supplements change attention, and it did not test FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/31109092/"
    },
    {
      "t": "Mousain-Bosc et al. (2004): magnesium with vitamin B6 in children",
      "s": "An open study of 52 children under 15 with signs of nervous-system hyperexcitability reported improvements in behavior and school attention after combined magnesium/B6 supplementation. It had no randomized placebo comparison, so it cannot establish cause or isolate either ingredient\u2019s effect. The combined regimen was not a test of FizzyFocus.",
      "c": "Mousain-Bosc et al. (2004): magnesium with vitamin B6 in children. An open study of 52 children under 15 with signs of nervous-system hyperexcitability reported improvements in behavior and school attention after combined magnesium/B6 supplementation. It had no randomized placebo comparison, so it cannot establish cause or isolate either ingredient\u2019s effect. The combined regimen was not a test of FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/15466962/"
    }
  ],
  "folate": [
    {
      "t": "Razavinia et al. (2024): folate and B12 levels in children with A*HD",
      "s": "A review of six studies in 982 children aged 6\u201312 found lower average folate and vitamin B12 in children with A*HD. The studies varied widely, and a 2023 review found folate higher, not lower, in A*HD. These are blood-level comparisons, not tests of supplements or of FizzyFocus.",
      "c": "Razavinia et al. (2024): folate and B12 levels in children with A*HD. A review of six studies in 982 children aged 6\u201312 found lower average folate and vitamin B12 in children with A*HD. The studies varied widely, and a 2023 review found folate higher, not lower, in A*HD. These are blood-level comparisons, not tests of supplements or of FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/38904980/"
    },
    {
      "t": "Ghanizadeh et al. (2013): folic acid alongside methylphenidate",
      "s": "An eight-week randomized, placebo-controlled trial in 49 children with A*HD added 5 mg/day folic acid to methylphenidate. Symptoms improved in both groups with no difference between them. It used a different form and a much higher amount than FizzyFocus\u2019s 150 mcg DFE L-methylfolate. This trial does not support a focus benefit for folate.",
      "c": "Ghanizadeh et al. (2013): folic acid alongside methylphenidate. An eight-week randomized, placebo-controlled trial in 49 children with A*HD added 5 mg/day folic acid to methylphenidate. Symptoms improved in both groups with no difference between them. It used a different form and a much higher amount than FizzyFocus\u2019s 150 mcg DFE L-methylfolate. This trial does not support a focus benefit for folate.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/24454418/"
    },
    {
      "t": "Surman et al. (2019): L-methylfolate added to methylphenidate in adults",
      "s": "A 12-week randomized, placebo-controlled trial enrolled 44 adults with A*HD and tested 15 mg/day L-methylfolate alongside methylphenidate. It found no meaningful added benefit for A*HD symptoms. This trial does not support a focus-benefit claim for L-methylfolate. Its dose, population and treatment setting differ from FizzyFocus, which provides 150 mcg DFE folate per serving.",
      "c": "Surman et al. (2019): L-methylfolate added to methylphenidate in adults. A 12-week randomized, placebo-controlled trial enrolled 44 adults with A*HD and tested 15 mg/day L-methylfolate alongside methylphenidate. It found no meaningful added benefit for A*HD symptoms. This trial does not support a focus-benefit claim for L-methylfolate. Its dose, population and treatment setting differ from FizzyFocus, which provides 150 mcg DFE folate per serving.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/30566416/"
    }
  ],
  "b12": [
    {
      "t": "Altun et al. (2018): B vitamins in children newly diagnosed with A*HD",
      "s": "A small case-control study of 30 children with A*HD and 30 without found lower vitamin B6, folate and B12 in the A*HD group; within that group, higher B12 went with higher IQ-test scores. It is a correlation in 60 children and does not show that B12 supplements change attention. FizzyFocus was not tested.",
      "c": "Altun et al. (2018): B vitamins in children newly diagnosed with A*HD. A small case-control study of 30 children with A*HD and 30 without found lower vitamin B6, folate and B12 in the A*HD group; within that group, higher B12 went with higher IQ-test scores. It is a correlation in 60 children and does not show that B12 supplements change attention. FizzyFocus was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/30267523/"
    },
    {
      "t": "Kvestad et al. (2015): B12, folic acid and early development",
      "s": "In a six-month randomized, placebo-controlled trial, development was assessed in 422 children aged 6\u201330 months. Combined B12 and folic acid improved gross-motor and problem-solving scores; the combination does not isolate B12\u2019s contribution. The study used cyanocobalamin and folic acid, not FizzyFocus\u2019s methylcobalamin and L-methylfolate, and did not study school-age focus.",
      "c": "Kvestad et al. (2015): B12, folic acid and early development. In a six-month randomized, placebo-controlled trial, development was assessed in 422 children aged 6\u201330 months. Combined B12 and folic acid improved gross-motor and problem-solving scores; the combination does not isolate B12\u2019s contribution. The study used cyanocobalamin and folic acid, not FizzyFocus\u2019s methylcobalamin and L-methylfolate, and did not study school-age focus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/26098427/"
    },
    {
      "t": "Kvestad et al. (2020): longer-term follow-up of B12 and folate",
      "s": "Follow-up testing at ages 6\u20139 found no cognitive advantage from the earlier six-month B12/folic-acid intervention. Read alongside the 2015 findings: an early developmental signal did not translate into a demonstrated long-term cognitive benefit. Neither study tested FizzyFocus.",
      "c": "Kvestad et al. (2020): longer-term follow-up of B12 and folate. Follow-up testing at ages 6\u20139 found no cognitive advantage from the earlier six-month B12/folic-acid intervention. Read alongside the 2015 findings: an early developmental signal did not translate into a demonstrated long-term cognitive benefit. Neither study tested FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/32019814/"
    }
  ],
  "saffron": [
    {
      "t": "Baziar et al. (2019): saffron compared with methylphenidate in children with A*HD",
      "s": "A six-week randomized, double-blind pilot in 54 children aged 6\u201317 with A*HD compared saffron capsules (20\u201330 mg/day by weight) with methylphenidate; 50 finished. Symptom ratings changed similarly in both groups. There was no placebo group, and a pilot this small cannot show the two are equal, so it does not support replacing prescribed treatment. FizzyFocus provides 15 mg affron\u00ae per serving and was not tested.",
      "c": "Baziar et al. (2019): saffron compared with methylphenidate in children with A*HD. A six-week randomized, double-blind pilot in 54 children aged 6\u201317 with A*HD compared saffron capsules (20\u201330 mg/day by weight) with methylphenidate; 50 finished. Symptom ratings changed similarly in both groups. There was no placebo group, and a pilot this small cannot show the two are equal, so it does not support replacing prescribed treatment. FizzyFocus provides 15 mg affron\u00ae per serving and was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/30741567/"
    },
    {
      "t": "Lopresti et al. (2018): affron\u00ae and mood in adolescents",
      "s": "Eight-week randomized, placebo-controlled trial; 80 adolescents aged 12\u201316 with mild-to-moderate anxiety or depressive symptoms were enrolled. At 28 mg/day, youth-rated symptoms improved versus placebo; parent reports were mixed. The trial used the affron\u00ae extract included in FizzyFocus, but FizzyFocus contains 15 mg per serving and was not tested as a finished formula. Researchers from the extract\u2019s maker co-authored it.",
      "c": "Lopresti et al. (2018): affron\u00ae and mood in adolescents. Eight-week randomized, placebo-controlled trial; 80 adolescents aged 12\u201316 with mild-to-moderate anxiety or depressive symptoms were enrolled. At 28 mg/day, youth-rated symptoms improved versus placebo; parent reports were mixed. The trial used the affron\u00ae extract included in FizzyFocus, but FizzyFocus contains 15 mg per serving and was not tested as a finished formula. Researchers from the extract\u2019s maker co-authored it.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/29510352/"
    },
    {
      "t": "Blasco-Fontecilla et al. (2022): saffron in children and teens with A*HD",
      "s": "In a nonrandomized study, families of 63 children and teens aged 7\u201317 with A*HD chose saffron (Saffr\u2019Activ, 30 mg/day) or methylphenidate for three months. Both groups improved. Without random assignment or a placebo, the design cannot show equivalence to medication or support replacing prescribed treatment. The lead author has a commercial interest in a saffron supplement, and the extract differs from the affron\u00ae in FizzyFocus.",
      "c": "Blasco-Fontecilla et al. (2022): saffron in children and teens with A*HD. In a nonrandomized study, families of 63 children and teens aged 7\u201317 with A*HD chose saffron (Saffr\u2019Activ, 30 mg/day) or methylphenidate for three months. Both groups improved. Without random assignment or a placebo, the design cannot show equivalence to medication or support replacing prescribed treatment. The lead author has a commercial interest in a saffron supplement, and the extract differs from the affron\u00ae in FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/36235697/"
    }
  ],
  "blueberry": [
    {
      "t": "Whyte et al. (2017): wild blueberry and executive-task performance",
      "s": "Double-blind crossover study in 21 children aged 7\u201310 without A*HD. A single 30 g dose of freeze-dried wild blueberry powder improved response speed on demanding executive-function tasks versus placebo three hours later. This is short-term ingredient research. FizzyFocus\u2019s entire three-fruit blend is 150 mg; its undisclosed blueberry amount cannot be equated to the studied preparation or dose.",
      "c": "Whyte et al. (2017): wild blueberry and executive-task performance. Double-blind crossover study in 21 children aged 7\u201310 without A*HD. A single 30 g dose of freeze-dried wild blueberry powder improved response speed on demanding executive-function tasks versus placebo three hours later. This is short-term ingredient research. FizzyFocus\u2019s entire three-fruit blend is 150 mg; its undisclosed blueberry amount cannot be equated to the studied preparation or dose.",
      "u": "https://doi.org/10.1039/C7FO00832E"
    },
    {
      "t": "Barfoot et al. (2019): wild blueberry drink in schoolchildren",
      "s": "A single-blind randomized study gave 54 healthy children aged 7\u201310 one wild blueberry drink (about 240 g of fresh berries) or a placebo drink. The blueberry group responded faster on one type of attention-task trial and recalled more words on a memory test; reading did not change. Single dose, children without A*HD, and the wild blueberry growers\u2019 association supplied the powder and funding. FizzyFocus\u2019s whole three-fruit blend is 150 mg.",
      "c": "Barfoot et al. (2019): wild blueberry drink in schoolchildren. A single-blind randomized study gave 54 healthy children aged 7\u201310 one wild blueberry drink (about 240 g of fresh berries) or a placebo drink. The blueberry group responded faster on one type of attention-task trial and recalled more words on a memory test; reading did not change. Single dose, children without A*HD, and the wild blueberry growers\u2019 association supplied the powder and funding. FizzyFocus\u2019s whole three-fruit blend is 150 mg.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/30327868/"
    }
  ],
  "cranberry": [
    {
      "t": "Flanagan et al. (2022): cranberry and visual memory in older adults",
      "s": "A 12-week randomized, placebo-controlled feasibility trial in 60 adults aged 50\u201380 used daily freeze-dried cranberry powder, equal to about one small cup of cranberries. Visual episodic memory improved versus placebo. The Cranberry Institute funded the study. No study of cranberry on attention or learning in children, or in A*HD, was found. FizzyFocus lists 150 mg for its combined three-fruit blend, not an individual cranberry dose.",
      "c": "Flanagan et al. (2022): cranberry and visual memory in older adults. A 12-week randomized, placebo-controlled feasibility trial in 60 adults aged 50\u201380 used daily freeze-dried cranberry powder, equal to about one small cup of cranberries. Visual episodic memory improved versus placebo. The Cranberry Institute funded the study. No study of cranberry on attention or learning in children, or in A*HD, was found. FizzyFocus lists 150 mg for its combined three-fruit blend, not an individual cranberry dose.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/35662954/"
    }
  ],
  "zinc": [
    {
      "t": "Talebi et al. (2022): zinc trials in children with A*HD",
      "s": "A review pooled six randomized trials of 489 children with A*HD. Zinc was linked with a small improvement in total symptom scores that only just reached statistical significance, with no clear effect on attention or hyperactivity scores on their own. The authors rated the certainty of evidence moderate to very low, and most of the positive trials came from regions where low zinc is more common. None of the trials tested FizzyFocus or zinc picolinate, the form it uses.",
      "c": "Talebi et al. (2022): zinc trials in children with A*HD. A review pooled six randomized trials of 489 children with A*HD. Zinc was linked with a small improvement in total symptom scores that only just reached statistical significance, with no clear effect on attention or hyperactivity scores on their own. The authors rated the certainty of evidence moderate to very low, and most of the positive trials came from regions where low zinc is more common. None of the trials tested FizzyFocus or zinc picolinate, the form it uses.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/34184967/"
    },
    {
      "t": "Akhondzadeh et al. (2004): zinc alongside methylphenidate",
      "s": "Six-week randomized, placebo-controlled trial in 44 children aged 5\u201311 with A*HD. Adding zinc sulfate, providing about 15 mg elemental zinc daily, improved parent and teacher rating scores versus medication plus placebo. This tested zinc as an adjunct to medication, not a replacement. FizzyFocus provides 12.5 mg zinc as picolinate per serving, a different form; the finished formula was not tested.",
      "c": "Akhondzadeh et al. (2004): zinc alongside methylphenidate. Six-week randomized, placebo-controlled trial in 44 children aged 5\u201311 with A*HD. Adding zinc sulfate, providing about 15 mg elemental zinc daily, improved parent and teacher rating scores versus medication plus placebo. This tested zinc as an adjunct to medication, not a replacement. FizzyFocus provides 12.5 mg zinc as picolinate per serving, a different form; the finished formula was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/15070418/"
    },
    {
      "t": "Bilici et al. (2004): zinc sulfate and behavior ratings",
      "s": "Twelve-week randomized, placebo-controlled trial in 400 children with A*HD used 150 mg/day zinc sulfate on its own (the compound amount, not elemental zinc). Hyperactivity, impulsivity and socialization ratings improved versus placebo; attention-deficit ratings did not. Full response rates were 28.7% with zinc and 20% with placebo. This does not establish a focus benefit for FizzyFocus or its different zinc form and dose.",
      "c": "Bilici et al. (2004): zinc sulfate and behavior ratings. Twelve-week randomized, placebo-controlled trial in 400 children with A*HD used 150 mg/day zinc sulfate on its own (the compound amount, not elemental zinc). Hyperactivity, impulsivity and socialization ratings improved versus placebo; attention-deficit ratings did not. Full response rates were 28.7% with zinc and 20% with placebo. This does not establish a focus benefit for FizzyFocus or its different zinc form and dose.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/14687872/"
    },
    {
      "t": "Arnold et al. (2011): zinc in US children with A*HD",
      "s": "A placebo-controlled pilot in 52 children aged 6\u201314 tested zinc glycinate for eight weeks, then alongside amphetamine. Zinc did not improve attention more than placebo, the study\u2019s main question. 15 mg once a day, the amount closest to FizzyFocus\u2019s 12.5 mg, showed no clear benefit; some test results favored 30 mg a day. FizzyFocus uses zinc picolinate and was not tested.",
      "c": "Arnold et al. (2011): zinc in US children with A*HD. A placebo-controlled pilot in 52 children aged 6\u201314 tested zinc glycinate for eight weeks, then alongside amphetamine. Zinc did not improve attention more than placebo, the study\u2019s main question. 15 mg once a day, the amount closest to FizzyFocus\u2019s 12.5 mg, showed no clear benefit; some test results favored 30 mg a day. FizzyFocus uses zinc picolinate and was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/21309695/"
    }
  ],
  "mag": [
    {
      "t": "Huang et al. (2019): magnesium levels in children with A*HD",
      "s": "A review of 12 studies found lower blood and hair magnesium in children with A*HD than in children without it. This shows an association, not that low magnesium causes symptoms or that supplements help. It did not test FizzyFocus.",
      "c": "Huang et al. (2019): magnesium levels in children with A*HD. A review of 12 studies found lower blood and hair magnesium in children with A*HD than in children without it. This shows an association, not that low magnesium causes symptoms or that supplements help. It did not test FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/30496768/"
    },
    {
      "t": "Hemamy et al. (2021): magnesium with vitamin D in children",
      "s": "Eight-week randomized, placebo-controlled trial in 66 children aged 6\u201312 with A*HD, all taking methylphenidate and all low in vitamin D and magnesium at the start. Magnesium (6 mg/kg/day) was given together with vitamin D (50,000 IU/week). After adjustment, total difficulties, peer problems and internalizing scores improved versus placebo; hyperactivity, attention and conduct scores did not. The combination cannot isolate magnesium, and it used a different regimen from FizzyFocus\u2019s 100 mg magnesium and 13 mcg vitamin D per serving. These research doses are not directions for use.",
      "c": "Hemamy et al. (2021): magnesium with vitamin D in children. Eight-week randomized, placebo-controlled trial in 66 children aged 6\u201312 with A*HD, all taking methylphenidate and all low in vitamin D and magnesium at the start. Magnesium (6 mg/kg/day) was given together with vitamin D (50,000 IU/week). After adjustment, total difficulties, peer problems and internalizing scores improved versus placebo; hyperactivity, attention and conduct scores did not. The combination cannot isolate magnesium, and it used a different regimen from FizzyFocus\u2019s 100 mg magnesium and 13 mcg vitamin D per serving. These research doses are not directions for use.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/33865361/"
    },
    {
      "t": "Mousain-Bosc et al. (2004): magnesium with vitamin B6 in children",
      "s": "An open study of 52 children under 15 with signs of nervous-system hyperexcitability reported improvements in behavior and school attention after combined magnesium/B6 supplementation. It had no randomized placebo comparison, so it cannot establish cause or isolate either ingredient\u2019s effect. The combined regimen was not a test of FizzyFocus.",
      "c": "Mousain-Bosc et al. (2004): magnesium with vitamin B6 in children. An open study of 52 children under 15 with signs of nervous-system hyperexcitability reported improvements in behavior and school attention after combined magnesium/B6 supplementation. It had no randomized placebo comparison, so it cannot establish cause or isolate either ingredient\u2019s effect. The combined regimen was not a test of FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/15466962/"
    }
  ],
  "pom": [
    {
      "t": "Siddarth et al. (2020): pomegranate juice and visual learning in middle-aged and older adults",
      "s": "A 12-month randomized, placebo-controlled trial enrolled 261 adults aged 50\u201375 and used 8 ounces of juice daily. One visual-learning measure remained stable with juice while declining with placebo; other memory outcomes did not differ. This is mixed, adult ingredient evidence at a preparation and amount not equivalent to FizzyFocus. The juice maker helped fund this trial. No study of pomegranate on attention in children, or in A*HD, was found.",
      "c": "Siddarth et al. (2020): pomegranate juice and visual learning in middle-aged and older adults. A 12-month randomized, placebo-controlled trial enrolled 261 adults aged 50\u201375 and used 8 ounces of juice daily. One visual-learning measure remained stable with juice while declining with placebo; other memory outcomes did not differ. This is mixed, adult ingredient evidence at a preparation and amount not equivalent to FizzyFocus. The juice maker helped fund this trial. No study of pomegranate on attention in children, or in A*HD, was found.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/31711104/"
    }
  ],
  "theanine": [
    {
      "t": "Kahathuduwa et al. (2020): exploratory attention study in children",
      "s": "Crossover pilot in five boys with A*HD used 2.5 mg/kg L-theanine plus 2 mg/kg caffeine. The pairing improved measured attention and cognition; its effect on inhibitory control was not statistically significant, and caffeine alone worsened that measure. The very small sample, different dose ratio and acute testing do not establish everyday benefits or long-term safety for children. FizzyFocus was not tested.",
      "c": "Kahathuduwa et al. (2020): exploratory attention study in children. Crossover pilot in five boys with A*HD used 2.5 mg/kg L-theanine plus 2 mg/kg caffeine. The pairing improved measured attention and cognition; its effect on inhibitory control was not statistically significant, and caffeine alone worsened that measure. The very small sample, different dose ratio and acute testing do not establish everyday benefits or long-term safety for children. FizzyFocus was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/32753637/"
    },
    {
      "t": "Nawarathna et al. (2026): L-theanine with caffeine in young people with A*HD",
      "s": "A placebo-controlled crossover study in 21 young people aged 10\u201319 with A*HD gave single weight-based doses of L-theanine with caffeine, methylphenidate or placebo. The pairing reduced responses to distracting stimuli compared with placebo; other attention measures did not improve. Allocation was not randomized, everyone in it already responded to methylphenidate, and it does not show the pairing can stand in for prescribed treatment. The findings are preliminary, and the study did not test FizzyFocus\u2019s fixed amounts.",
      "c": "Nawarathna et al. (2026): L-theanine with caffeine in young people with A*HD. A placebo-controlled crossover study in 21 young people aged 10\u201319 with A*HD gave single weight-based doses of L-theanine with caffeine, methylphenidate or placebo. The pairing reduced responses to distracting stimuli compared with placebo; other attention measures did not improve. Allocation was not randomized, everyone in it already responded to methylphenidate, and it does not show the pairing can stand in for prescribed treatment. The findings are preliminary, and the study did not test FizzyFocus\u2019s fixed amounts.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/42096377/"
    },
    {
      "t": "Perrotte et al. (2023): caffeine alone in children with A*HD",
      "s": "A review of seven small randomized trials (104 children aged 5\u201315 with A*HD), six of them from 1975\u20131981, found no clear benefit from caffeine on its own compared with placebo; pooling four of the trials, it found no difference in overall symptoms. Doses were 75\u2013309 mg; none tested FizzyFocus\u2019s 50 mg, and none tested caffeine with L-theanine.",
      "c": "Perrotte et al. (2023): caffeine alone in children with A*HD. A review of seven small randomized trials (104 children aged 5\u201315 with A*HD), six of them from 1975\u20131981, found no clear benefit from caffeine on its own compared with placebo; pooling four of the trials, it found no difference in overall symptoms. Doses were 75\u2013309 mg; none tested FizzyFocus\u2019s 50 mg, and none tested caffeine with L-theanine.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/37759905/"
    },
    {
      "t": "Lyon et al. (2011): L-theanine and sleep in boys with A*HD",
      "s": "A six-week randomized, placebo-controlled trial in 98 boys aged 8\u201312 with A*HD studied 400 mg L-theanine daily and found improvements in some objective sleep measures. This was a sleep study, not evidence of improved attention. It used four times FizzyFocus\u2019s 100 mg and contained no caffeine.",
      "c": "Lyon et al. (2011): L-theanine and sleep in boys with A*HD. A six-week randomized, placebo-controlled trial in 98 boys aged 8\u201312 with A*HD studied 400 mg L-theanine daily and found improvements in some objective sleep measures. This was a sleep study, not evidence of improved attention. It used four times FizzyFocus\u2019s 100 mg and contained no caffeine.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/22214254/"
    }
  ],
  "vitd": [
    {
      "t": "Gan et al. (2019): vitamin D trials in children with A*HD",
      "s": "A review pooled four randomized trials of 256 children with A*HD who took vitamin D alongside methylphenidate. It reported small improvements in symptom scores, with side effects similar to placebo. The authors rated the evidence low to very low quality, and trial doses were higher than FizzyFocus\u2019s 520 IU per serving.",
      "c": "Gan et al. (2019): vitamin D trials in children with A*HD. A review pooled four randomized trials of 256 children with A*HD who took vitamin D alongside methylphenidate. It reported small improvements in symptom scores, with side effects similar to placebo. The authors rated the evidence low to very low quality, and trial doses were higher than FizzyFocus\u2019s 520 IU per serving.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/31368773/"
    },
    {
      "t": "Mohammadpour et al. (2018): vitamin D alongside methylphenidate",
      "s": "Eight-week randomized, placebo-controlled trial in 62 children aged 5\u201312 with A*HD; 54 completed it. Vitamin D at 2,000 IU/day alongside methylphenidate improved evening behavior ratings, but two other symptom scales did not differ between groups. FizzyFocus provides 520 IU (13 mcg) per serving. This was adjunctive treatment research at a different dose, not a trial of FizzyFocus.",
      "c": "Mohammadpour et al. (2018): vitamin D alongside methylphenidate. Eight-week randomized, placebo-controlled trial in 62 children aged 5\u201312 with A*HD; 54 completed it. Vitamin D at 2,000 IU/day alongside methylphenidate improved evening behavior ratings, but two other symptom scales did not differ between groups. FizzyFocus provides 520 IU (13 mcg) per serving. This was adjunctive treatment research at a different dose, not a trial of FizzyFocus.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/27924679/"
    }
  ],
  "ps": [
    {
      "t": "Hirayama et al. (2014): soy-derived phosphatidylserine in children",
      "s": "Two-month randomized, placebo-controlled trial in 36 children aged 4\u201314 with A*HD who had not taken A*HD medication used 200 mg/day soy-derived phosphatidylserine. The supplement group improved on symptom scores, short-term auditory memory and some attention measures while the placebo group did not change; the paper\u2019s summary gives no direct comparison between groups. Several authors worked for ingredient companies. FizzyFocus provides 100 mg per serving and has not been tested as a finished formula.",
      "c": "Hirayama et al. (2014): soy-derived phosphatidylserine in children. Two-month randomized, placebo-controlled trial in 36 children aged 4\u201314 with A*HD who had not taken A*HD medication used 200 mg/day soy-derived phosphatidylserine. The supplement group improved on symptom scores, short-term auditory memory and some attention measures while the placebo group did not change; the paper\u2019s summary gives no direct comparison between groups. Several authors worked for ingredient companies. FizzyFocus provides 100 mg per serving and has not been tested as a finished formula.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/23495677/"
    },
    {
      "t": "Bruton et al. (2021): phosphatidylserine trials in children with A*HD",
      "s": "A review pooled three small randomized trials (216 children) at 200\u2013300 mg/day. It found a small improvement in attention scores versus placebo but no clear effect on overall or hyperactivity scores, and rated the evidence low quality. Some pooled trials used phosphatidylserine combined with omega-3, a different ingredient from FizzyFocus\u2019s soy phosphatidylserine. FizzyFocus provides 100 mg per serving and was not tested.",
      "c": "Bruton et al. (2021): phosphatidylserine trials in children with A*HD. A review pooled three small randomized trials (216 children) at 200\u2013300 mg/day. It found a small improvement in attention scores versus placebo but no clear effect on overall or hyperactivity scores, and rated the evidence low quality. Some pooled trials used phosphatidylserine combined with omega-3, a different ingredient from FizzyFocus\u2019s soy phosphatidylserine. FizzyFocus provides 100 mg per serving and was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/33539192/"
    },
    {
      "t": "Jaicks and Kinter (2026): different phosphatidylserine amounts in children",
      "s": "A small four-arm randomized, placebo-controlled trial in 45 children aged 10\u201314 with A*HD or A*HD symptoms compared three phosphatidylserine products for eight weeks. Only the 150 mg product with DHA clearly improved attention-test results; the roughly 100 mg products changed about as much as placebo. It is newly published and not yet replicated. FizzyFocus provides 100 mg per serving and was not tested.",
      "c": "Jaicks and Kinter (2026): different phosphatidylserine amounts in children. A small four-arm randomized, placebo-controlled trial in 45 children aged 10\u201314 with A*HD or A*HD symptoms compared three phosphatidylserine products for eight weeks. Only the 150 mg product with DHA clearly improved attention-test results; the roughly 100 mg products changed about as much as placebo. It is newly published and not yet replicated. FizzyFocus provides 100 mg per serving and was not tested.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/42345137/"
    }
  ],
  "grape": [
    {
      "t": "Bell et al. (2022): grape-seed extract and cognition in young adults",
      "s": "Randomized, placebo-controlled trial in 60 adults aged 18\u201330 tested 400 mg/day grape-seed polyphenol extract acutely and over 12 weeks. Some individual tasks improved, but there was no consistent cognitive benefit versus placebo. FizzyFocus contains 100 mg grape-seed extract per serving. This trial does not substantiate a cognitive-benefit claim for that dose or for children. No study of grape seed extract in children or in A*HD was found.",
      "c": "Bell et al. (2022): grape-seed extract and cognition in young adults. Randomized, placebo-controlled trial in 60 adults aged 18\u201330 tested 400 mg/day grape-seed polyphenol extract acutely and over 12 weeks. Some individual tasks improved, but there was no consistent cognitive benefit versus placebo. FizzyFocus contains 100 mg grape-seed extract per serving. This trial does not substantiate a cognitive-benefit claim for that dose or for children. No study of grape seed extract in children or in A*HD was found.",
      "u": "https://pubmed.ncbi.nlm.nih.gov/31942838/"
    }
  ]
};

  function escapeAttr(s) {
    return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;');
  }
  function escapeHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  /* ────────────── MASTER-DETAIL CONTROLLER ──────────────
     Build the tiles + detail-card structure ONCE on init. Selection
     changes just update text/src/class in place — no innerHTML rebuild
     of the parent, so the <img> element survives the swap and only its
     src attribute changes. Browser cache makes that instant; no
     "disappear and reappear" flicker.
  */
  function initIngredients() {
    var tilesEl  = document.getElementById('ingTiles');
    var detailEl = document.getElementById('ingDetail');
    if (!tilesEl || !detailEl) return;

    // ── 1. Build tiles once ──
    tilesEl.innerHTML = INGREDIENTS.map(function (ing, i) {
      return '<button class="ing-tile" data-i="' + i + '" type="button" aria-pressed="false" aria-controls="ingDetail">'
           +   '<span class="th">'
           +     '<span class="swatch" style="background:' + escapeAttr(ing.swatch) + '"></span>'
           +     '<img src="' + escapeAttr(ing.img) + '" alt="" loading="lazy">'
           +   '</span>'
           +   '<span>'
           +     '<span class="t-name">' + escapeHtml(ing.n) + '</span>'
           +     '<span class="t-bene">' + escapeHtml(ing.bene) + '</span>'
           +   '</span>'
           + '</button>';
    }).join('');

    // ── 2. Build detail card skeleton once ──
    // + icon used in both accordion heads — rotated 45° via CSS when [data-open="true"] to read as ×
    var plusIcon =
          '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">'
        +   '<line x1="7" y1="2" x2="7" y2="12"/>'
        +   '<line x1="2" y1="7" x2="12" y2="7"/>'
        + '</svg>';

    detailEl.innerHTML =
        '<div class="d-fade">'
      +   '<div class="d-top">'
      +     '<div class="d-ph">'
      +       '<span class="swatch"></span>'
      +       '<img alt="">'
      +     '</div>'
      +     '<div>'
      +       '<span class="d-kind"></span>'
      +       '<h3 class="d-name" aria-live="polite"></h3>'
      +       '<p class="d-form"></p>'
      +     '</div>'
      +   '</div>'
      +   '<div class="d-stats">'
      +     '<div class="d-stat"><div class="k">Per serving</div><div class="v" data-field="dose"></div></div>'
      +     '<div class="d-stat"><div class="k">Ingredient context</div><div class="v" data-field="src"></div></div>'
      +   '</div>'
      +   '<div class="ing-acc" data-open="false">'
      +     '<button type="button" class="ing-acc-head" aria-expanded="false">'
      +       '<span class="ing-acc-label">What is it</span>'
      +       '<span class="ing-acc-icon">' + plusIcon + '</span>'
      +     '</button>'
      +     '<div class="ing-acc-body"><p data-field="whatIsIt"></p></div>'
      +   '</div>'
      +   '<div class="ing-acc" data-open="true">'
      +     '<button type="button" class="ing-acc-head" aria-expanded="true">'
      +       '<span class="ing-acc-label">Why we use it</span>'
      +       '<span class="ing-acc-icon">' + plusIcon + '</span>'
      +     '</button>'
      +     '<div class="ing-acc-body"><p data-field="desc"></p></div>'
      +   '</div>'
      +   '<div class="ing-acc ing-acc-refs" data-open="false" hidden>'
      +     '<button type="button" class="ing-acc-head" aria-expanded="false">'
      +       '<span class="ing-acc-label">Clinical ingredient studies</span>'
      +       '<span class="ing-acc-icon">' + plusIcon + '</span>'
      +     '</button>'
      +     '<div class="ing-acc-body"><ol class="ing-refs" data-field="refs"></ol></div>'
      +   '</div>'
      +   '<div class="d-foot"></div>'
      + '</div>';

    // Cache element refs once — saves a querySelector on every selection
    var dImg     = detailEl.querySelector('.d-ph img');
    var dSwatch  = detailEl.querySelector('.d-ph .swatch');
    var dKind    = detailEl.querySelector('.d-kind');
    var dName    = detailEl.querySelector('.d-name');
    var dForm    = detailEl.querySelector('.d-form');
    var dDose    = detailEl.querySelector('[data-field="dose"]');
    var dSrc     = detailEl.querySelector('[data-field="src"]');
    var dWhat    = detailEl.querySelector('[data-field="whatIsIt"]');
    var dDesc    = detailEl.querySelector('[data-field="desc"]');
    var dFoot    = detailEl.querySelector('.d-foot');
    var accs     = detailEl.querySelectorAll('.ing-acc');
    var dRefs    = detailEl.querySelector('.ing-refs');
    var dRefsAcc = detailEl.querySelector('.ing-acc-refs');
    var dRefsLbl = dRefsAcc ? dRefsAcc.querySelector('.ing-acc-label') : null;

    // ── 3. Update-in-place selector ──
    function selectIngredient(active) {
      var ing = INGREDIENTS[active];
      if (!ing) return;


      // Tile active state — toggle class, no DOM rebuild
      tilesEl.querySelectorAll('.ing-tile').forEach(function (b, i) {
        b.classList.toggle('active', i === active);
        b.setAttribute('aria-pressed', i === active ? 'true' : 'false');
      });

      // Detail card fields — text/src updates, no element replacement
      dImg.src = ing.img;
      dSwatch.style.background = ing.swatch;
      dKind.textContent = ing.kind;
      dName.textContent = ing.n;
      // "as <form>" subtitle — matches the parenthetical form in the SFP.
      // Hidden when an ingredient has no distinct form (whole-food extracts).
      if (dForm) {
        if (ing.form) {
          dForm.textContent = 'as ' + ing.form;
          dForm.hidden = false;
        } else {
          dForm.textContent = '';
          dForm.hidden = true;
        }
      }
      dDose.textContent = ing.dose;
      dSrc.textContent = ing.src;
      dWhat.textContent = ing.whatIsIt;
      dDesc.textContent = ing.desc;

      // Chips vary in count per ingredient — they're text-only spans
      // so a small innerHTML rebuild here is cheap and flicker-free.
      dFoot.innerHTML = ing.chips.map(function (c) {
        return '<span class="chip">' + escapeHtml(c) + '</span>';
      }).join('');

      // Clinical ingredient studies — curated citations keyed by ingredient. Hidden for
      // ingredients without a verified source in the current ledger.
      var rlist = REFS[ing.k] || [];
      if (dRefsAcc) {
        if (rlist.length) {
          dRefs.innerHTML = rlist.map(function (r) {
            var c = escapeHtml(r.c);
            return '<li>' + (r.u ? '<a href="' + escapeAttr(r.u) + '" target="_blank" rel="noopener nofollow">' + escapeHtml(r.t || r.c) + '</a>' : c) + (r.s ? '<br>' + escapeHtml(r.s) : '') + '</li>';
          }).join('');
          if (dRefsLbl) dRefsLbl.textContent = 'Clinical ingredient studies (' + rlist.length + ')';
          dRefsAcc.hidden = false;
        } else {
          dRefs.innerHTML = '';
          dRefsAcc.hidden = true;
        }
      }

      // Reset accordion state to defaults (first closed, second open)
      // — matches the previous rebuild behavior.
      if (accs[0]) {
        accs[0].setAttribute('data-open', 'false');
        var h0 = accs[0].querySelector('.ing-acc-head');
        if (h0) h0.setAttribute('aria-expanded', 'false');
      }
      if (accs[1]) {
        accs[1].setAttribute('data-open', 'true');
        var h1 = accs[1].querySelector('.ing-acc-head');
        if (h1) h1.setAttribute('aria-expanded', 'true');
      }
      if (accs[2]) {
        accs[2].setAttribute('data-open', 'false');
        var h2 = accs[2].querySelector('.ing-acc-head');
        if (h2) h2.setAttribute('aria-expanded', 'false');
      }
    }

    // ── 4. Wire events once ──
    tilesEl.querySelectorAll('.ing-tile').forEach(function (b) {
      b.addEventListener('click', function () {
        selectIngredient(parseInt(b.dataset.i, 10));
      });
    });

    detailEl.querySelectorAll('.ing-acc-head').forEach(function (head) {
      head.addEventListener('click', function () {
        var acc = head.closest('.ing-acc');
        var open = acc.getAttribute('data-open') === 'true';

        if (!open) {
          detailEl.querySelectorAll('.ing-acc[data-open="true"]').forEach(function (other) {
            if (other === acc) return;
            other.setAttribute('data-open', 'false');
            var otherHead = other.querySelector('.ing-acc-head');
            if (otherHead) otherHead.setAttribute('aria-expanded', 'false');
          });
        }

        acc.setAttribute('data-open', open ? 'false' : 'true');
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    // ── 5. Initial selection ──
    selectIngredient(0);
  }

  /* ────────────── MOBILE: ACCORDION LIST ──────────────
     Replaces the master-detail layout on narrow viewports. Each ingredient
     is rendered as a native <details> accordion. Items 7-12 are hidden by
     default (CSS); a "View all" button toggles .show-all on the wrapper. */
  function initIngredientsMobile() {
    var wrap = document.getElementById('ingMobile');
    var listEl = document.getElementById('ingMobileList');
    var toggleBtn = document.getElementById('ingMobileToggle');
    if (!wrap || !listEl || !toggleBtn) return;

    listEl.innerHTML = INGREDIENTS.map(function (ing) {
      return ''
        + '<details class="ing-mob">'
        +   '<summary class="ing-mob-head">'
        +     '<span class="ing-mob-thumb">'
        +       '<span class="swatch" style="background:' + escapeAttr(ing.swatch) + '"></span>'
        +       '<img src="' + escapeAttr(ing.img) + '" alt="" loading="lazy">'
        +     '</span>'
        +     '<span class="ing-mob-meta">'
        +       '<span class="ing-mob-name">' + escapeHtml(ing.n) + '</span>'
        +       '<span class="ing-mob-bene">' + escapeHtml(ing.bene) + '</span>'
        +     '</span>'
        +     '<span class="ing-mob-toggle" aria-hidden="true">'
        +       '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="7" y1="2" x2="7" y2="12"/><line x1="2" y1="7" x2="12" y2="7"/></svg>'
        +     '</span>'
        +   '</summary>'
        +   '<div class="ing-mob-body">'
        +     (ing.form ? '<p class="ing-mob-form">as ' + escapeHtml(ing.form) + '</p>' : '')
        +     '<div class="ing-mob-stats">'
        +       '<div><div class="k">Per serving</div><div class="v">' + escapeHtml(ing.dose) + '</div></div>'
        +       '<div><div class="k">Ingredient context</div><div class="v">' + escapeHtml(ing.src) + '</div></div>'
        +     '</div>'
        +     '<div class="ing-mob-block">'
        +       '<div class="lbl">What is it</div>'
        +       '<p>' + escapeHtml(ing.whatIsIt) + '</p>'
        +     '</div>'
        +     '<div class="ing-mob-block">'
        +       '<div class="lbl">Why we use it</div>'
        +       '<p>' + escapeHtml(ing.desc) + '</p>'
        +     '</div>'
        +     ((REFS[ing.k] && REFS[ing.k].length) ?
                '<details class="ing-mob-block ing-mob-refs">'
              +   '<summary class="ing-mob-refs-sum">'
              +     '<span class="lbl">Clinical ingredient studies (' + REFS[ing.k].length + ')</span>'
              +     '<svg class="ing-mob-refs-chev" viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="4 6 8 10 12 6"/></svg>'
              +   '</summary>'
              +   '<ol class="ing-refs">'
              +     REFS[ing.k].map(function (r) { var c = escapeHtml(r.c); return '<li>' + (r.u ? '<a href="' + escapeAttr(r.u) + '" target="_blank" rel="noopener nofollow">' + escapeHtml(r.t || r.c) + '</a>' : c) + (r.s ? '<br>' + escapeHtml(r.s) : '') + '</li>'; }).join('')
              +   '</ol>'
              + '</details>' : '')
        +     '<div class="ing-mob-foot">'
        +       ing.chips.map(function (c) { return '<span class="chip">' + escapeHtml(c) + '</span>'; }).join('')
        +     '</div>'
        +   '</div>'
        + '</details>';
    }).join('');

    // View all / Show less toggle
    var labelEl = toggleBtn.querySelector('.ing-mobile-toggle-label');
    toggleBtn.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('show-all');
      toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (labelEl) {
        labelEl.textContent = expanded ? 'Show less' : 'View all ingredients';
      }
    });

    // ── Single-open behavior ──
    // Native <details>/<summary> handles open/close on click — no
    // animation, instant snap. We just listen for the `toggle` event
    // and close any other open row when one opens.
    var rows = listEl.querySelectorAll('.ing-mob');
    rows.forEach(function (row) {
      row.addEventListener('toggle', function () {
        if (!row.hasAttribute('open')) return;
        rows.forEach(function (other) {
          if (other !== row && other.hasAttribute('open')) {
            other.removeAttribute('open');
          }
        });
      });
    });
  }

  function init() {
    initIngredients();
    initIngredientsMobile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
